import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, CustomInput } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import CKEditor from "ckeditor4-react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import moment from "moment";
import imageCompression from "browser-image-compression";



const ImgUpload = ({ onChange, src }) => (
    <label htmlFor="photo-upload" className="custom-file-upload fas">
        <div className="img-wrap img-upload">
            <img
                for="photo-upload"
                src={src}
                style={{ width: "100%", height: "100%", borderRadius: "5%" }}
            />
        </div>
        <input accept="image/*" id="photo-upload" type="file" onChange={onChange} />
    </label>
);

class AddBoard extends Component {
    constructor(props) {
        super(props);
        const { action } = props.match.params;
        ////console.log("param " + action);
        this.state = {
            imagePreviewUrl:
                "https://www.pngrepo.com/png/46739/170/add-to-shopping-bag.png",
            ImageApiUrl: JSON.parse(localStorage.getItem("ClientDetails"))[0].fld_apiaddress + "AddImage",
            Status: "Yes",
            ImageData: [],
            VerticalData: [],
            BoardName: "",
            BoardId: null,
            Action: action,
            BoardDescription: "",
            Verticalname: "",
            originalImage: [],
            originalLink: "",
            clicked: false,
            uploadImage: false,

            ImageName: null,
            BoardImage: null,
            Cost: null,
            Margin: null,
            GSM: null,
            DecimalRegex: /^(\d*\.?\d{0,2}|\.\d{0,9})$/,
        };
    }

    componentDidMount() {
        Notiflix.Loading.Init({
            svgColor: "#777f80",
        });




        var det = localStorage.getItem("BoardDetails");
        var BoardData = JSON.parse(det);

        if (BoardData != null) {
            if (this.state.Action == "update") {
                this.setState({
                    BoardName: BoardData.fld_board_name,
                    BoardId: BoardData.fld_board_id,
                    Status: BoardData.fld_status == 'Active' ? 'Yes' : 'No',
                    Cost: BoardData.fld_cost,
                    Margin: BoardData.fld_margin
                    // GSM: BoardData.fld_gsm,

                });
            }

            if (BoardData.fld_image != null) {
                this.setState({
                    imagePreviewUrl: BoardData.fld_image,
                    BoardImage: BoardData.fld_image,
                });
            } else {
                this.setState({
                    imagePreviewUrl:
                        "https://www.pngrepo.com/png/46739/170/add-to-shopping-bag.png",
                });
            }

            if (this.state.Action == "update") {
                new Promise((resolve, reject) => {
                    setTimeout(resolve, 1000);
                }).then(() => {
                    this.setState({
                        BoardDescription: BoardData.fld_description,
                        // TermsCondition:OfferData.fld_termscondition,
                    });
                });
            }
        }
    }

    // ==Image Upload onChange Function=======
    photoUpload = (e) => {
        e.preventDefault();
        const imageFile = e.target.files[0];
        this.setState({
            imagePreviewUrl: URL.createObjectURL(imageFile),
            originalImage: imageFile,
            outputFileName: imageFile.name,
            uploadImage: true
        });
    };



    onChangeDescription(text) {
        this.setState({
            BoardDescription: text.editor.getData(),
        });
    }

    onSaveData() {
        if (this.state.BoardName != "") {
            if (
                this.state.imagePreviewUrl !=
                "https://www.pngrepo.com/png/46739/170/add-to-shopping-bag.png"
            ) {
                if (this.state.Cost != null) {
                    if (this.state.Margin != null) {
                        this.onPost();
                    }
                    else {
                        Notiflix.Notify.Failure("Please enter margin");
                    }
                }
                else {
                    Notiflix.Notify.Failure("Please enter the board cost");
                }
            } else {
                Notiflix.Notify.Failure("Please upload board image");
            }
        } else {
            Notiflix.Notify.Failure("Please enter the board name");
        }

    }

    onPost = () => {
        Notiflix.Loading.Dots("Please wait...");
        var login = localStorage.getItem("LoginDetail");
        var details = JSON.parse(login);

        if (this.state.BoardId == null) {

            if (this.state.BoardImage != this.state.imagePreviewUrl) {

                if (this.state.outputFileName != undefined) {

                    PostApiCall.postRequest(
                        {
                            boardid: this.state.BoardId,
                            boardname: this.state.BoardName,
                            gsm: this.state.GSM,
                            description: this.state.BoardDescription,
                            status: this.state.Status == "Yes" ? "Active" : "Inactive",
                            cost: this.state.Cost,
                            margin: this.state.Margin,
                            image: JSON.parse(localStorage.getItem("ClientDetails"))[0].fld_image_url_path + "/BoardImages/" +
                                this.state.BoardName.trim().replace(/\s/g, "-") + "-" + this.state.outputFileName,

                        },
                        "BoardMaster"
                    ).then((resultcategory) =>
                        resultcategory.json().then((obj) => {
                            if (resultcategory.status == 200 || resultcategory.status == 201) {
                                Notiflix.Notify.Success("Board successfully added. Image upload in process");

                                this.onUploadImage(obj);

                            } else {
                                Notiflix.Loading.Remove();
                                Notiflix.Notify.Failure(obj.data);
                            }
                        })
                    );

                } else {
                    Notiflix.Loading.Remove();
                    Notiflix.Notify.Failure("Please Upload Board Image");
                }
            }
            else {
                this.onUpdateBoard()
            }
        }
        else {

            this.onUpdateBoard()
        }

    }



    onUpdateBoard = () => {

        PostApiCall.postRequest(
            {
                boardid: this.state.BoardId,
                boardname: this.state.BoardName,
                gsm: this.state.GSM,
                description: this.state.BoardDescription,
                status: this.state.Status == "Yes" ? "Active" : "Inactive",
                cost: this.state.Cost,
                margin: this.state.Margin,
                image: this.state.imagePreviewUrl,

            },
            "BoardMaster"
        ).then((resultcategory) =>
            resultcategory.json().then((obj) => {
                if (resultcategory.status == 200 || resultcategory.status == 201) {
                    Notiflix.Notify.Success("Coating successfully added. Image upload in process");

                    this.onUploadImage(obj);
                } else {
                    Notiflix.Loading.Remove();
                    Notiflix.Notify.Failure(obj.data);
                }
            })
        );

    }



    async onUploadImage(obj) {
        Notiflix.Loading.Dots("Uploading Images...");

        let response;

        if (this.state.outputFileName != undefined) {

            var options = {
                maxSizeMB: 0.05,
                maxWidthOrHeight: 1920,
                useWebWorker: true
            }
            imageCompression(this.state.originalImage, options)
                .then((compressedFile) => {



                    const form = new FormData();

                    form.append("file", compressedFile);
                    form.append("foldername", "BoardImages");
                    form.append(
                        "filename",
                        this.state.BoardName.trim().replace(/\s/g, "-") +
                        "-" +
                        compressedFile.name

                    );
                    response = fetch(this.state.ImageApiUrl, {
                        method: "POST",
                        body: form,
                    }).then(response => response.json())
                        .then(data => {

                            Notiflix.Loading.Remove()
                            Notiflix.Notify.Success("Image successfully uploaded.")
                            window.location.href = "/board_master";
                        }

                        )
                    // //console.log(response);


                })
        }
        else {
            Notiflix.Loading.Remove()
            Notiflix.Notify.Success("Image successfully uploaded.")
            window.location.href = "/board_master";
        }




    }

    render() {
        // //console.log(this.state.imagePreviewUrl)

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs breadcrumbItem={"Board Master"} breadcrumbItem1={this.state.BoardId == null ? "Add New Board" : "Update Board"} urlPath={"/board_master"} urlPath1={this.state.BoardId == null ? "/add_board/create" : "/add_board/update"} />
                        <Row>
                            <Col xl="12">


                                <Card className="overflow-hidden">
                                    <div className="Bechofy-bg-soft-pink">
                                        <Row>
                                            <Col xs="3">
                                                <div className="Bechofy-text p-3">
                                                    {this.state.BoardId == null ?
                                                        <h5 className="Bechofy-text">
                                                            Add New Board
                                                        </h5>
                                                        :
                                                        <h5 className="Bechofy-text">
                                                            Update Board
                                                        </h5>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <CardBody className="pt-0">
                                        <Row>
                                            <Col xs="12">
                                                <div className="form my-4">
                                                    <div className="row  ">
                                                        <div className="col col-12">
                                                            <div className="row">

                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label for="BoardName">
                                                                            Board Name
                                                                            <span className="mandatory">*</span>
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            id="BoardName"
                                                                            className="form-control"
                                                                            value={this.state.BoardName}
                                                                            onChange={(text) => {
                                                                                this.setState({
                                                                                    BoardName: text.target.value,
                                                                                });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                {/* <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label for="BoardName">
                                                                            Board GSM
                                                                            <span className="mandatory">*</span>
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            id="GSM"
                                                                            className="form-control"
                                                                            value={this.state.GSM}
                                                                            onChange={(text) => {
                                                                                this.setState({
                                                                                    GSM: text.target.value,
                                                                                });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div> */}
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label for="BoardName">
                                                                            Cost Per Kg
                                                                            <span className="mandatory">*</span>
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            id="BoardName"
                                                                            className="form-control"
                                                                            value={this.state.Cost}
                                                                            onChange={(text) => {
                                                                                if (
                                                                                    this.state.DecimalRegex.test(text.target.value)) {
                                                                                    this.setState({
                                                                                        Cost: text.target.value,
                                                                                    })
                                                                                };
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label for="BoardName">
                                                                            Margin (in percentage)
                                                                            <span className="mandatory">*</span>
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            id="BoardName"
                                                                            className="form-control"
                                                                            value={this.state.Margin}
                                                                            onChange={(text) => {
                                                                                if (
                                                                                    this.state.DecimalRegex.test(text.target.value)) {
                                                                                    this.setState({
                                                                                        Margin: text.target.value,
                                                                                    })
                                                                                };
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-3">
                                                                    <div className="form-group">
                                                                        <label for="BoardName">
                                                                            Show on Website
                                                                            <span className="mandatory">*</span>
                                                                        </label>
                                                                        <br />
                                                                        <label class="radio-inline">
                                                                            <input
                                                                                type="radio"
                                                                                name="optradio"
                                                                                //  disabled={!this.state.IsVisible}
                                                                                checked={
                                                                                    this.state.Status == "Yes"
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                onChange={() => {
                                                                                    this.setState({
                                                                                        Status: "Yes",
                                                                                    });
                                                                                }}
                                                                            />{" "}
                                                                            Yes
                                                                        </label>
                                                                        <label
                                                                            class="radio-inline"
                                                                            style={{ marginLeft: "10px" }}
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                name="optradio"
                                                                                //  disabled={!this.state.IsVisible}
                                                                                checked={
                                                                                    this.state.Status == "No"
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                onChange={() => {
                                                                                    this.setState({
                                                                                        Status: "No",
                                                                                    });
                                                                                }}
                                                                            />{" "}
                                                                            No
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="col-12">
                                                                    <div class="form-group">
                                                                        <label for="sw-arrows-first-name">
                                                                            Description(maximum 500 Characters)
                                                                        </label>

                                                                        <div class="niceeditors">
                                                                            <CKEditor
                                                                                config={{
                                                                                    extraPlugins:
                                                                                        "justify,font,colorbutton",
                                                                                }}
                                                                                data={this.state.BoardDescription}
                                                                                onChange={this.onChangeDescription.bind(
                                                                                    this
                                                                                )}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-1"></div>
                                                            <div class="col-md-11">
                                                                <label for="sw-arrows-first-name">
                                                                    Upload Board Image (Size
                                                                    1500*1500)<span className="mandatory">*</span>
                                                                </label>
                                                                <div class="div1">
                                                                    <ImgUpload
                                                                        onChange={this.photoUpload}
                                                                        src={this.state.imagePreviewUrl}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card>
                                    <CardBody className="py-1 my-1">
                                        <Row>
                                            <Col xs="12">
                                                <div className="row">
                                                    <div className="col-3 offset-9">
                                                        <button
                                                            style={{ float: "right" }}
                                                            className="btn align-items-center Bechofy-btn "
                                                            onClick={this.onSaveData.bind(this)}
                                                        >
                                                            {this.state.BoardId == null ? <span>Save Board</span> : <span>Update Board</span>}
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                    {/*                
                </Card>
       
                              
                               
                               
                            </Col>
                               </Row> */}
                                    {/* </Card> */}
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}
export default AddBoard;